import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withWidth from '@material-ui/core/withWidth';

import theme from '../../theme';
import CardHeader from './card-header';
import CardTable from './card-table';
import Header from '../../components/header';
// import TokenBalances from '../../components/TokenBalances';
import CardUnauthorized from './card-unauthorized';

class Staking extends React.Component {
  colors() {
    const { global } = this.props;
    if (global.dark) {
      return theme.palette.dark;
    }
    return theme.palette.light;
  }
  componentDidMount() {
    window.gtag('event', 'conversion', { send_to: 'AW-328866151/kmV8CIv7gegCEOey6JwB' });
  }

  render() {
    const { global, address } = this.props;

    const styleCard = {
      minHeight: '700px',
      borderRadius: '20px',
      border: !global.dark ? '1px solid #D2D6E8' : 'none',
      backgroundColor: this.colors().cardBackground,
      overflow: 'initial',
    };

    return (
      <div className='container'>
        <Header />
        <Grid container>
          <Grid item xs={12} md={12} xl={12}>
            <Card elevation={0} style={styleCard}>
              <CardHeader />
              {address ? <CardTable /> : <CardUnauthorized />}
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

Staking.propTypes = {
  global: PropTypes.object.isRequired,
  address: PropTypes.string,
};

Staking.defaultProps = {
  address: '',
};

const mapStateToProps = (state) => ({
  dark: state.basic.dark,
  light: state.basic.light,
  address: state.account.address,
});

const enhance = compose(withWidth(), connect(mapStateToProps));

export default enhance(withTheme(Staking));
